export default {"src":"/_next/static/media/bag-green.bb1cb430.svg","height":25,"width":27,"blurWidth":0,"blurHeight":0};